export const SAVE_CHANGES_BEFORE_APPROVAL_MESSAGE =
  'Please save your changes before selecting this option!'
